var render = function render() {
  var _vm$sectionData, _vm$sectionData2, _vm$sectionData3;
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "post-section-2"
  }, [_c("VideoPlayer", {
    attrs: {
      playbackId: (_vm$sectionData = _vm.sectionData) === null || _vm$sectionData === void 0 || (_vm$sectionData = _vm$sectionData.video) === null || _vm$sectionData === void 0 ? void 0 : _vm$sectionData.playbackId,
      posterImageUrl: (_vm$sectionData2 = _vm.sectionData) !== null && _vm$sectionData2 !== void 0 && _vm$sectionData2.thumbnail ? _vm.urlForImage(_vm.sectionData.thumbnail).width(2000).url() : ""
    }
  }), _c("p", {
    staticClass: "video-title"
  }, [_vm._v(_vm._s((_vm$sectionData3 = _vm.sectionData) === null || _vm$sectionData3 === void 0 ? void 0 : _vm$sectionData3.title))])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };